export function unpackSnapshotArray({ snapshots }: { snapshots: any }) {
  const results: any[] = [];
  snapshots.forEach((snapshot: any) => {
    results.push({ id: snapshot.id, ...snapshot.data() });
  });
  return results;
}
